import { signal } from "@preact/signals-react";

export const loggedInUser = signal(null);
export const smeCurrentViewCompoent = signal("home");
export const smeDoubtListUserId = signal(null);
export const smeDoubtListUserName = signal(null)
export const smeDoubtChatSessionId = signal(null);
export const smeDoubtChatSession = signal(null);